import React from 'react';
import { PageTitle } from '@cordata/buffet';

import Form from '~/components/ScheduledReport/Form';

const ScheduledReportsAdd = () => (
  <>
    <PageTitle>Add Scheduled Report</PageTitle>

    <Form data={{}} />
  </>
);

export default ScheduledReportsAdd;
